import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=ce0098d6&scoped=true"
import script from "./SuggestionList.vue?vue&type=script&lang=js"
export * from "./SuggestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0098d6",
  null
  
)

export default component.exports